import { Autocomplete, RadioButton } from '@weareopenr/component-library';
import styles from '../MenuModal/MenuModal.module.scss';
import {
  Control,
  FieldErrors,
  useController,
  UseFormClearErrors,
  UseFormRegister,
  UseFormSetValue,
  UseFormTrigger,
  UseFormWatch,
} from 'react-hook-form';
import { EntitySource } from '../../constants';
import { IOptionGroupValues } from '../CreateOptionGroupModal/types';

interface IProductRangeSelectorProps {
  ranges: { range_id: string; name: string }[];
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  errors: FieldErrors<any>;
  watch: UseFormWatch<any>;
  clearErrors: UseFormClearErrors<any>;
  trigger?: UseFormTrigger<IOptionGroupValues>;
  productType: 'BUNDLE' | 'STANDARD';
  control: Control<any>;
  isDisabled?: boolean;
}

export const ProductRangeSelector = ({
  ranges,
  register,
  watch,
  errors,
  clearErrors,
  trigger,
  productType,
  control,
  isDisabled = false,
}: IProductRangeSelectorProps) => {
  const source = watch('source');

  const {
    field: { onChange, value },
  } = useController({
    control,
    name: 'ranges',
  });

  return (
    <>
      <RadioButton name={'source'} value={EntitySource.LIBRARY} register={register} disabled={isDisabled}>
        Use Product Library
      </RadioButton>
      <RadioButton
        name={'source'}
        value={EntitySource.RANGES}
        register={register}
        disabled={!ranges || ranges?.length === 0 || isDisabled}
      >
        Use Product Range(s)
      </RadioButton>

      <div className={styles['autocomplete']}>
        <Autocomplete
          multiple
          name="ranges"
          label="Product Range"
          options={(ranges || []).map((range) => ({ value: range.range_id, label: range.name }))}
          value={value ?? []}
          onChange={(rangeIds) => {
            if (isDisabled) return;
            clearErrors('ranges');
            onChange(rangeIds);
            if (productType === 'STANDARD') {
              trigger?.('modifiers');
            }
          }}
          limitChips={2}
          disabled={isDisabled || source === EntitySource.LIBRARY}
          error={errors.ranges?.message?.toString()}
        />
      </div>
    </>
  );
};
